import React from "react";
import PropTypes from "prop-types";
import { defineMessages, useIntl } from "react-intl";
import FormItem from "theme/components/molecules/Form/Item";
import { Text, Textarea } from "theme/components/atoms/Form/Input";

const messages = defineMessages({
  errorRequired: {
    id: "components.atoms.Form.Input.requiredError",
    defaultMessage: "This is a required field",
  },
  nameLabel: {
    id: "modules.RequisitionList.Modal.name",
    defaultMessage: "Name",
  },
  descriptionLabel: {
    id: "modules.RequisitionList.Modal.description",
    defaultMessage: "Description",
  },
});

const RequisitionListModalForm = ({ requisitionList }) => {
  const intl = useIntl();

  return (
    <>
      <FormItem label={intl.formatMessage(messages.nameLabel)}>
        <Text
          id="name"
          name="name"
          required
          validationError={intl.formatMessage(messages.errorRequired)}
          value={requisitionList ? requisitionList.name : null}
        />
      </FormItem>

      <FormItem label={intl.formatMessage(messages.descriptionLabel)}>
        <Textarea
          id="description"
          name="description"
          value={requisitionList ? requisitionList.description : ""}
        />
      </FormItem>
    </>
  );
};

RequisitionListModalForm.propTypes = {
  requisitionList: PropTypes.any,
};

export default RequisitionListModalForm;
